import React, { FC } from 'react';

import { NRDProperties } from '../../../../models/water/nebraska';
import { capitalizeEveryWord } from '../../../../utils/common';
import Typography from '../../typography';

interface IProps {
  item: NRDProperties;
}

const NRDName: FC<IProps> = ({ item }) => (
  <div className="flex flex-col text-gray-100">
    <Typography className="mb-3" variant="h5">
      {capitalizeEveryWord(item.NRD_NAME)}
    </Typography>

    <Typography className="!font-semibold" variant="legal">
      Allocation <span className="!font-normal">{item.Alloc}</span>
    </Typography>

    <Typography className="!font-semibold" variant="legal">
      Flow Meter{' '}
      <span className="!font-normal">
        {capitalizeEveryWord(item.Flow_Meter)}
      </span>
    </Typography>

    <Typography className="!font-semibold" variant="legal">
      Moratorium{' '}
      <span className="!font-normal">
        {capitalizeEveryWord(item.Moratorium)}
      </span>
    </Typography>
  </div>
);

export default NRDName;
